import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";

import CustomTitleWithInput from "components/base/CustomTitleWithInput";
import CustomTitleWithSwitch from "components/base/CustomTitleWithSwitch";
import BasePrompt from "components/base/prompt/BasePrompt";
import { CustomTitleWithDropDown } from "components/customer/CustomTitleWithDropDown";
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import { ADDITIONAL_FIELD_FORMAT_TYPE, DISPLAY_ADDITIONAL_FIELD_FORMAT_TYPE, LanguageConfig } from "config/CustomEnums";
import LanguageTabs from "components/base/LanguageTab";
import ErrorFieldMessage, { hasErrorFromList } from "components/base/ErrorFieldMessage";

import DeleteIcon from 'assets/images/deleteIcon.png';

import "./AdditionalQuestionPrompt.scss"
import { isTicketCampaignOtherInformationQuestionShowOption } from "models/CreateCampaignModel";

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});
const AdditionalQuestionPrompt = ({
  languages,
  defaultValue,
  show = false,
  setShow = () => { },
  onComfirm = () => { },
}) => {
  const [translations, setTranslations] = useState({});
  const [fieldFormat, setFieldFormat] = useState({});
  const [isOptional, setIsOptional] = useState(false);
  const [fieldOptions, setFieldOptions] = useState([]);

  const [errors, setErrors] = useState([]);

  const showFieldOptions = isTicketCampaignOtherInformationQuestionShowOption({ fieldFormat: fieldFormat?.value?.value })


  const clearData = () => {
    setTranslations({})
    setFieldFormat("")
    setIsOptional(false)
    setFieldOptions([])
  }

  const appendNewOption = () => {
    setFieldOptions([...fieldOptions, {}])
  }

  useEffect(() => {
    if (!showFieldOptions) {
      return;
    }
    if (!fieldOptions || fieldOptions?.length < 1) {
      appendNewOption()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showFieldOptions])

  useEffect(() => {
    if (!show) {
      return
    }
    if (show && defaultValue) {
      setTranslations(defaultValue?.translations || {})
      setFieldFormat(defaultValue?.fieldFormat || {})
      setIsOptional(defaultValue?.isOptional || false)
      setFieldOptions(defaultValue?.fieldOptions || [])
      return;
    }
    if (show) {
      appendNewOption()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  const formValidate = () => {
    let err = []
    if (!translations?.[LanguageConfig.english]?.fieldName) {
      err.push({ name: "fieldName", msg: "Please input field name." })
    }
    if (!fieldFormat?.value?.value) {
      err.push({ name: "fieldFormat", msg: "Please input field format." })
    }
    if (showFieldOptions) {
      fieldOptions?.length > 0 && fieldOptions.forEach((option, index) => {
        if (!option?.[LanguageConfig.english]) {
          err.push({ name: `fieldOptions.${index}`, msg: "Please input field option." })
        }
      })
    }
    setErrors(err)
    return err?.length < 1
  }

  const addOptionByIndex = ({ newVlaue, index, language }) => {
    const newOption = { ...fieldOptions?.[index] || {}, [language]: newVlaue }
    let newArr = [...fieldOptions]
    newArr[index] = newOption
    setFieldOptions(newArr)
  }

  const removeOptionByIndex = ({ index }) => {
    const newArr = [...fieldOptions]
    newArr.splice(index, 1)
    setFieldOptions(newArr)
  }

  const getLanguageTabs = (language) => {
    return (
      <>
        <CustomTitleWithInput
          useDefaultValue={false}
          title={"Input field name (Hint)"}
          defaultValue={translations?.[language]?.fieldName || ""}
          setValue={(value) => {
            setTranslations({ ...translations, [language]: { ...translations?.[language] || {}, fieldName: value } })
          }}
          customClass={"width-400px"}
        />
        {language === LanguageConfig.english &&
          <>
            <ErrorFieldMessage
              id={"fieldName"}
              error={hasErrorFromList(errors, "fieldName")}
              message={hasErrorFromList(errors, "fieldName")?.msg || ""}
            />
            <CustomTitleWithDropDown
              title={"Field format"}
              needFilter={false}
              labelContainPk={false}
              defaultValue={fieldFormat}
              source={
                Object.values(ADDITIONAL_FIELD_FORMAT_TYPE)?.map(item => ({
                  value: ADDITIONAL_FIELD_FORMAT_TYPE[item],
                  name: DISPLAY_ADDITIONAL_FIELD_FORMAT_TYPE?.[item]
                }))}
              setValue={setFieldFormat}
              loadMoreAction=''
              filterAction=''
              customClass={"width-400px"}
            />
            <ErrorFieldMessage
              id={"fieldFormat"}
              error={hasErrorFromList(errors, `fieldFormat`)}
              message={hasErrorFromList(errors, `fieldFormat`)?.msg || ""}
            />
          </>
        }
        {showFieldOptions && (
          <>
            <CustomTitleLabel title={"Field options"} />
            {fieldOptions?.map((optionTranslations, index, arr) => (
              <>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <CustomTitleWithInput
                    customClass={"width-400px"}
                    defaultValue={optionTranslations?.[language] || ""}
                    useDefaultValue={false}
                    setValue={(newVlaue) => {
                      addOptionByIndex({ newVlaue, index, language})
                    }}
                  />
                  {arr.length !== 1 && language === LanguageConfig.english &&
                    <button
                      className="delete-condition-group-button"
                      type="button"
                      onClick={() => {
                        removeOptionByIndex({ index, language })
                      }}
                    >
                      <Image src={DeleteIcon} className="content-delete-button" />
                    </button>
                  }
                </div>
                <ErrorFieldMessage
                  id={`fieldOptions.${index}`}
                  error={hasErrorFromList(errors, `fieldOptions.${index}`)}
                  message={hasErrorFromList(errors, `fieldOptions.${index}`)?.msg || ""}
                />
              </>

            ))}
            <button
              style={{ marginTop: "12px" }}
              className="btn-back-button-common content-add-button"
              type="button"
              onClick={() => {
                appendNewOption()
              }}
            >
              {"Add option"}
            </button>
          </>
        )}
        {language === LanguageConfig.english &&
          <CustomTitleWithSwitch
            title={"Is optional field?"}
            tips={`If the question is optional (toggle on), a wording "(optional)" will be added at the end of the title name.`}
            defaultValue={isOptional}
            setValue={(value) => {
              setIsOptional(value)
            }}
          />}
      </>
    )
  }

  const promptBody = () => (<>
    <LanguageTabs
      containers={languages?.map((language) => ({
        key: language.code,
        title: language.sourceName,
        container: getLanguageTabs(language.code),
      }))}
      languageTabsStyle={"time-slot-languages-tabs"}
    />
  </>
  )

  return <BasePrompt
    customClass={"additional-field-prompt"}
    show={show}
    closeAction={() => {
      setShow(false)
      clearData()
    }}
    leftButton={{
      text: 'Cancel',
      action: () => {
        setShow(false)
        clearData()
      }
    }}
    rightButton={{
      text: 'Confirm',
      action: () => {
        if (formValidate()) {
          onComfirm({
            translations,
            fieldFormat,
            isOptional,
            fieldOptions: showFieldOptions ? fieldOptions : [],
          })
          setShow(false)
          clearData()
        }
      }
    }}
    title={'Add additional question'}
    otherBody={promptBody}
  />
}
export default connect(mapPropsToState)(AdditionalQuestionPrompt);
